// Keep titles/descriptions inside Google's display limits (Arial pixel widths, as SEO crawlers measure).
const W = {
  " ": 278, a: 556, b: 556, c: 500, d: 556, e: 556, f: 278, g: 556, h: 556, i: 222, j: 222, k: 500, l: 222,
  m: 833, n: 556, o: 556, p: 556, q: 556, r: 333, s: 500, t: 278, u: 556, v: 500, w: 722, x: 500, y: 500, z: 500,
  A: 667, B: 667, C: 722, D: 722, E: 667, F: 611, G: 778, H: 722, I: 278, J: 500, K: 667, L: 556, M: 833, N: 722,
  O: 778, P: 667, Q: 778, R: 722, S: 667, T: 611, U: 722, V: 667, W: 944, X: 667, Y: 667, Z: 611,
  "|": 260, "-": 333, "–": 556, "—": 1000, ",": 278, ".": 278, "&": 667, "'": 191, "’": 222, "/": 278, ":": 278,
  "?": 556, "!": 278, "(": 333, ")": 333, "%": 889, "$": 556, "+": 584, "#": 556,
};

export const pxWidth = (s, size) => [...s].reduce((sum, ch) => sum + (W[ch] ?? 556), 0) * size / 1000;

const TITLE_PX = 561;
const TITLE_CHARS = 60;
const BRANDS = [" | Prosper Garage Door Repair", " | Prosper Garage Door"];
const fitsTitle = (t) => t.length <= TITLE_CHARS && pxWidth(t, 20) <= TITLE_PX;
const DANGLING = /\s+(in|for|the|a|an|and|of|to|on|with|&|at|by|or|your|our)$/i;

const cutWords = (s, ok) => {
  const words = s.split(" ");
  const clean = () => words.join(" ").replace(/[\s,;:|–—(-]+$/, "").replace(DANGLING, "");
  while (words.length > 1 && !ok(clean())) words.pop();
  return clean();
};

// "Main | Brand" -> longest brand variant that fits, else main alone, else a shorter natural phrase.
export function fitTitle(title) {
  if (!title || fitsTitle(title)) return title;
  const main = title.split(" | ")[0];
  if (!main.includes("Prosper Garage Door")) for (const b of BRANDS) if (fitsTitle(main + b)) return main + b;
  if (fitsTitle(main)) return main;
  const candidates = [
    main.replace(/\s*\([^)]*\)/g, ""),
    main.split(": ")[0],
    main.split(" — ")[0],
  ].map((c) => c.trim());
  const q = main.indexOf("? ");
  if (q > 0) candidates.unshift(main.slice(0, q + 1));
  const hit = candidates.find((c) => c.length >= 25 && fitsTitle(c));
  return hit || cutWords(main, fitsTitle);
}

const fitsDesc = (d) => d.length <= 155 && pxWidth(d, 13) <= 960;

export function fitDesc(desc) {
  if (!desc || fitsDesc(desc)) return desc;
  const sentences = desc.match(/[^.!?]+[.!?]+/g) || [];
  let out = "";
  for (const s of sentences) {
    if (!fitsDesc((out + s).trim())) break;
    out += s;
  }
  out = out.trim();
  if (out.length >= 90) return out;
  return cutWords(desc, (t) => fitsDesc(t + "…")) + "…";
}
